import {
  ActionType,
  createReducer,
  createStandardAction
} from "typesafe-actions";

type SearchActionType = "SHOW_SEARCH" | "HIDE_SEARCH";
export const showSearch = createStandardAction<SearchActionType>(
  "SHOW_SEARCH"
)();
export const hideSearch = createStandardAction<SearchActionType>(
  "HIDE_SEARCH"
)();

const SearchActions = { showSearch, hideSearch };
export type SearchAction = ActionType<typeof SearchActions>;

export interface SearchState {
  open: boolean;
}

export const defaultSearchState: SearchState = {
  open: false
};

export const SearchReducer = createReducer(defaultSearchState)
  .handleAction(showSearch, state => ({
    ...state,
    open: true
  }))
  .handleAction(hideSearch, state => ({
    ...state,
    open: false
  }));
